// /pwa-courier — с этой страницы курьер ставит PWA: иконка «Домой» откроет /login, не лендинг
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import BrandFooter from '../components/BrandFooter';
import { STAFF_PWA_COURIER, STAFF_PWA_KEY } from '../lib/staffPwa';

const MANIFEST_COURIER = `${process.env.PUBLIC_URL || ''}/manifest-courier.json`;

export default function CourierPwaPage() {
  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]');
    const prev = link ? link.getAttribute('href') : null;
    if (link) {
      link.setAttribute('href', MANIFEST_COURIER);
    }
    try {
      localStorage.setItem(STAFF_PWA_KEY, STAFF_PWA_COURIER);
    } catch (_) { /* no-op */ }
    return () => {
      if (link && prev != null) link.setAttribute('href', prev);
    };
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(180deg, #0d3d12 0%, #1b5e20 40%, #f5f5f7 40%)',
        fontFamily: '-apple-system, sans-serif',
        padding: '24px 16px 32px',
        paddingTop: 'max(24px, env(safe-area-inset-top, 0px))',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          maxWidth: 440,
          margin: '0 auto',
          background: '#fff',
          borderRadius: 20,
          padding: 24,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        }}
      >
        <div style={{ fontSize: 40, textAlign: 'center', marginBottom: 8 }}>🚗</div>
        <h1 style={{ fontSize: 22, fontWeight: 800, textAlign: 'center', margin: '0 0 8px' }}>
          Ilova: kuryer
        </h1>
        <p style={{ fontSize: 13, color: '#666', textAlign: 'center', margin: '0 0 20px' }}>
          Keyin: «Bosh ekran» orqali darhol <strong>kirish</strong> (asosiy bet emas)
        </p>
        <hr style={{ border: 'none', borderTop: '1px solid #eee', margin: '16px 0' }} />
        <h2 style={{ fontSize: 16, fontWeight: 700, margin: '0 0 12px' }}>Русский</h2>
        <ol style={{ fontSize: 14, lineHeight: 1.5, color: '#333', paddingLeft: 20, margin: 0 }}>
          <li>
            Останьтесь <strong>на этой странице</strong> (она задаёт «правильный» PWA для курьера).
          </li>
          <li>Откройте меню браузера → «На экран Домой» / «Install app» / «Добавить…».</li>
          <li>
            Готово: иконка сразу ведёт на <strong>вход курьера</strong>, а не на рекламу tez-hop.
          </li>
        </ol>
        <p style={{ fontSize: 12, color: '#888', marginTop: 16, lineHeight: 1.45 }}>
          Если PWA устанавливали с главной tez-hop.uz, иконка открывала лендинг — удалите иконку и установите
          <strong> заново с этой страницы</strong>{' '}
          <code style={{ fontSize: 11 }}>/pwa-courier</code>.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 20 }}>
          <Link
            to="/login?hint=courier"
            style={{
              display: 'block',
              textAlign: 'center',
              background: '#1B5E20',
              color: '#fff',
              fontWeight: 700,
              padding: 14,
              borderRadius: 12,
              textDecoration: 'none',
            }}
          >
            Ко входу (email/пароль)
          </Link>
          <Link
            to="/"
            style={{ textAlign: 'center', color: '#007AFF', fontSize: 14, textDecoration: 'none' }}
          >
            ← Главная tez-hop.uz
          </Link>
        </div>
      </div>
      <div style={{ marginTop: 24, maxWidth: 440, marginLeft: 'auto', marginRight: 'auto' }}>
        <BrandFooter linkColor="#fff" dark />
      </div>
    </div>
  );
}
